import { useCallback } from 'react';
import type { EntityId } from '../../../../dependency/manager/types';
import type { DependencyGraphSubscriptions } from '../../../../dependency/subscription/DependencyGraphSubscriptions';
import { useAppDependencyGraphProvider } from '../DependencyGraphProvider';
import { useDependencyGraphProvider } from './useDependencyGraphProvider';

function useGetSubscribeToDependencyUpdates(subscriptionManager: DependencyGraphSubscriptions) {
  const subscribeToDependencyUpdates = useCallback(
    ({ callback, id, key = 'default' }: { callback: () => void; id: EntityId; key?: string }) => {
      subscriptionManager.subscribe({
        id,
        callback,
        key,
      });

      return () => {
        subscriptionManager.unsubscribe({
          id,
          key,
        });
      };
    },
    [subscriptionManager],
  );

  return { subscribeToDependencyUpdates };
}

export function useGetPageSubscribeToDependencyUpdates() {
  const { subscriptionManager } = useDependencyGraphProvider();
  const { subscribeToDependencyUpdates } = useGetSubscribeToDependencyUpdates(subscriptionManager);
  return { subscribeToDependencyUpdates };
}

export function useGetAppSubscribeToDependencyUpdates() {
  const { subscriptionManager } = useAppDependencyGraphProvider();
  const { subscribeToDependencyUpdates } = useGetSubscribeToDependencyUpdates(subscriptionManager);
  return { subscribeToDependencyUpdates };
}
